/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RankingInfoFromJSON, RankingInfoToJSON, } from './RankingInfo';
import { ProfileFromJSON, ProfileToJSON, } from './Profile';
/**
 * Check if a given object implements the UserRankingItem interface.
 */
export function instanceOfUserRankingItem(value) {
    if (!('user' in value) || value['user'] === undefined)
        return false;
    if (!('ranks' in value) || value['ranks'] === undefined)
        return false;
    return true;
}
export function UserRankingItemFromJSON(json) {
    return UserRankingItemFromJSONTyped(json, false);
}
export function UserRankingItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'user': ProfileFromJSON(json['user']),
        'ranks': RankingInfoFromJSON(json['ranks']),
    };
}
export function UserRankingItemToJSON(json) {
    return UserRankingItemToJSONTyped(json, false);
}
export function UserRankingItemToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'user': ProfileToJSON(value['user']),
        'ranks': RankingInfoToJSON(value['ranks']),
    };
}
